import { render, staticRenderFns } from "./OdometerGauge.vue?vue&type=template&id=0c4944c2&scoped=true&"
import script from "./OdometerGauge.vue?vue&type=script&lang=js&"
export * from "./OdometerGauge.vue?vue&type=script&lang=js&"
import style0 from "./OdometerGauge.vue?vue&type=style&index=0&id=0c4944c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4944c2",
  null
  
)

export default component.exports